import { useTranslation } from "react-i18next";
import { createFileRoute } from "@tanstack/react-router";
import { SearchPageLayout } from "~/components/layout/SearchPageLayout";
import { CvrCompanySearch } from "../-components/CvrCompanySearch";

export const Route = createFileRoute("/(restricted)/virksomheder/(search)")({
  component: CvrCompanySearchPage,
  loader: async ({ context: { i18n } }) => {
    await i18n.loadNamespaces("companies");

    const title = i18n.t("companies:search.meta.title");

    return { meta: { title } };
  },
  head: (context) => {
    return {
      meta: [
        {
          title: context.loaderData?.meta.title,
        },
      ],
    };
  },
});

function CvrCompanySearchPage() {
  const { t } = useTranslation(["companies"]);

  return (
    <SearchPageLayout
      headline={t("companies:search.headline")}
      caption={t("companies:search.caption")}
      mobileDisclaimer={t("companies:search.mobile_disclaimer")}
    >
      <CvrCompanySearch
        placeholder={t("companies:search.input.placeholder")}
        size="hero"
      />
    </SearchPageLayout>
  );
}
